module.exports = __webpack_public_path__ + "34e2fe800e61ce4b6d6edeb0fde02433.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/stars-patern.png
 ** module id = 150
 ** module chunks = 1
 **/